export enum Permissions {
  ACCESS_KEYS = 'access-keys',
  ADMIN_BRANDING = 'admin-branding',
  ADVANCED_MIS = 'advanced-mis',
  ADVANCED_MIS_VIEW = 'advanced-mis-view',
  ARCHIVE_LIST = 'archive-list',
  ASSIGN_LICENSE = 'assign-license',
  ATTACH_LIST_TO_NODE = 'attach-list-to-node',
  CREATE_LIST = 'create-list',
  DELETE_LIST = 'delete-list',
  EDIT_LIST = 'edit-list',
  EDIT_NODE = 'edit-node',
  GRANT_ANY_ROLE = 'grant-any-role',
  GRANT_THIS_ROLE = 'grant-this-role',
  HOME_MESSAGE = 'home-message',
  LIST_ACCESS_CONTROL = 'list-access-control',
  LIST_ANALYTICS = 'list-analytics',
  LTI_DEBUG = 'lti-debug',
  PUBLISH_LIST = 'publish-list',
  RECEIVE_NEW_REVIEW_REQUESTS_BY_EMAIL = 'receive-new-review-requests-by-email',
  REQUEST_DIGITISATION = 'request-digitisation',
  REQUEST_REVIEW = 'request-review',
  REQUEST_ROLLOVER = 'request-rollover',
  RESOURCE_METADATA_REFRESH = 'resource-metadata-refresh',
  UPLOAD_HIERARCHY = 'upload-hierarchy',
  V2_LIST_VIEW = 'v2-list-view',
  V2_LIST_EDIT = 'v2-list-edit',
  V2_CONFIGURE_LIST_BETA = 'v2-configure-list-beta',
  VIEW_ACQUISITIONS = 'view-acquisitions',
  VIEW_REPORTS = 'view-reports',
  ADMINISTER_SETTINGS = 'administer-settings',
  REQUEST_COURSE_RESERVE = 'request-course-reserve',
  UPLOAD_RESOURCE_FILE = 'upload-file-to-list',
}

/**
 * Returns a GRANT_THIS_ROLE permission string for a given role by appending '-' then the role code.
 * Without doing this we have no way to know which role the permission refers to, since we extract permissions away from roles.
 * For example, we need to know if a user has permission to grant the 'list publisher' role for the 'Invite list publishers' edit action on a list.
 * @param {string} role - The role from which the GRANT_THIS_ROLE permission came
 * @returns {string} - The permission string
 */
export function grantThisRolePermission(role: string): string {
  return Permissions.GRANT_THIS_ROLE + '-' + role;
}
